import {
	OrderStatusIncomingPalletGenerationAllowed,
	OrderStatusMovementAndReservationPallet,
} from "entities/OrderStatus";

import { useOrderServiceType } from "./useOrderServiceType";

export const usePalletGenerationGate = (order) => {
	const { isIncomingPlukk, isOutgoingPlukk, isCrossDock } = useOrderServiceType(order);

	const isSupported = isIncomingPlukk || isOutgoingPlukk || isCrossDock;

	let isBlockedByStatus;
	if (isIncomingPlukk || isCrossDock) {
		isBlockedByStatus = !OrderStatusIncomingPalletGenerationAllowed.includes(order?.status);
	} else {								
		isBlockedByStatus = !OrderStatusMovementAndReservationPallet.includes(order?.status);
	}
	return { isSupported, isBlockedByStatus };
};
